import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { RootAppState } from 'store/types';
import { localize } from 'core/localization';
import { withRouter } from 'react-router-dom';
import { CssAnimation } from 'components/common';
import { BUTTON } from 'constants/components';
import withNavigation from 'components/hocs/withNavigation';
import { RESULTS_PATH } from 'constants/navigation';
import TimeOut from 'assets/figures/TimeOut';
import * as courseTimerActions from 'store/timer/actions';
import { TimerStatus } from 'constants/timer';
import { shouldSubmitAllQuestions } from 'store/settings/selectors';
import { getCourseStructure } from 'store/course/selectors';
import { getUnansweredQuestions } from 'store/questions/selectors';
import * as treeOfContentActions from 'store/treeOfContent/actions';
import * as courseQuestionActions from 'store/questions/actions';
import { CourseStructure } from 'components/timer/types';
import {
  DescriptionWrapper,
  TitleElement,
  TimedOutWrapper,
  ButtonElement
} from './TimedOut.styled';

type TimedOutProps = {
  closePopup(): void;
  navigateToUrl(url: string): void;
  submitAllQuestionsEnabled: boolean;
  unansweredQuestions: any[];
  courseStructure: CourseStructure;
  timerActions: { [key: string]: any };
  tocActions: { [key: string]: any };
  questionActions: { [key: string]: any };
  courseActions: { [key: string]: any };
  popupSettings: { [key: string]: any };
};

const updateUnAnsweredQuestions = (
  submitAllQuestionsEnabled: boolean,
  unansweredQuestions: any[],
  questionActions: { [key: string]: any },
  tocActions: { [key: string]: any },
  courseStructure: CourseStructure
) => {
  if (submitAllQuestionsEnabled) {
    tocActions.submitAllAnswerOnce(courseStructure.sections);
  } else {
    unansweredQuestions.forEach(({ id }: any) => {
      questionActions.answer(id);
    });
  }
};

export const TimedOut: React.FunctionComponent<TimedOutProps> = (props: TimedOutProps) => {
  const {
    submitAllQuestionsEnabled,
    unansweredQuestions,
    courseStructure,
    questionActions,
    timerActions,
    tocActions,
    closePopup,
    navigateToUrl
  } = props;

  const goToResults = async () => {
    timerActions.setTimerStatus(TimerStatus.STOPPED);
    updateUnAnsweredQuestions(
      submitAllQuestionsEnabled,
      unansweredQuestions,
      questionActions,
      tocActions,
      courseStructure
    );
    closePopup();
    navigateToUrl(RESULTS_PATH);
  };

  return (
    <CssAnimation type={CssAnimation.AnimationType.fadeInDown}>
      <TimedOutWrapper>
        <TimeOut />
        <TitleElement>{localize('[timed out title]')}</TitleElement>
        <DescriptionWrapper>{localize('[timed out description]')}</DescriptionWrapper>
        <ButtonElement layout={BUTTON.LAYOUT.PRIMARY} onClick={goToResults}>
          {localize('[go to results]')}
        </ButtonElement>
      </TimedOutWrapper>
    </CssAnimation>
  );
};

function mapStateToProps(state: RootAppState) {
  return {
    submitAllQuestionsEnabled: shouldSubmitAllQuestions(state),
    courseStructure: getCourseStructure(state),
    unansweredQuestions: getUnansweredQuestions(state)
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    timerActions: bindActionCreators(courseTimerActions, dispatch),
    tocActions: bindActionCreators(treeOfContentActions, dispatch),
    questionActions: bindActionCreators(courseQuestionActions, dispatch)
  };
}

export default withRouter(withNavigation(connect(mapStateToProps, mapDispatchToProps)(TimedOut)));
